function postData(url, fields) {
  /*
   * The backend is expecting this data
   * as a regular form post and not an
   * ajax call, so we need to build an
   * html form and post it programatically.
   *
   * Also, we can't just build the form with
   * React because we need to parse some
   * values before posting them.
   */
  const form = document.createElement('form')

  form.action = url
  form.method = 'POST'
  form.style.display = 'none'

  for (let name in fields) {
    const field = document.createElement('input')

    field.name = name
    field.value = fields[name]

    form.appendChild(field)
  }

  document.body.appendChild(form)

  form.submit()
}

export default postData
